// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1sv6v","approved":"Status_approved__dHAZc","rejected":"Status_rejected__1q920","expired":"Status_expired__1KC16","label":"Status_label__2B3Pq"};